import moment from 'moment';

export function getPeriodoRelatorio(dataInicio?: string | null, dataFim?: string | null) {
  if (!dataInicio && dataFim) {
    return `Desde o início até ${moment(dataFim).format("DD/MM/YYYY")}`
  } else if (!dataInicio && !dataFim) {
    return `Sem período definido`
  }

  return `De ${moment(dataInicio).format("DD/MM/YYYY")} até ${moment(dataFim).format("DD/MM/YYYY")}`
}